export { initDataHtmlClass };
const initDataHtmlClass = 'react-streaming_initData';
